import FormFieldDuplicator from '@/js/components/form_field_duplicator/form_field_duplicator';
import ActionHandler from '@/js/components/forms/action_handler';
import ActionComponent from '@/js/components/forms/action_component';
import Validation from '@/js/components/forms/validation';
import Datepicker from '@/js/components/datepicker/datepicker';
import Inputmask from 'inputmask';
import { rootWithLanguage } from '@/js/utils/paths';

class CourseRegistration extends ActionHandler {
  constructor() {
    super();
    this.dom = {
      requestElements: [...document.querySelectorAll('[data-request-url]')],
      datepickers: [...document.querySelectorAll('[data-datepicker]')],
      formParticipants: document.getElementById('form-participants'),
      formCourseItems: document.getElementById('form-course-items'),
      formInvoice: document.getElementById('form-invoice'),
      formConfirm: document.getElementById('form-confirm'),
      inputMasks: [...document.querySelectorAll('[data-input-mask]')],
      selects: [...document.querySelectorAll('select[data-bs-target]')],
      updatePriceSelectors: [...document.querySelectorAll('input[name="Programs[]"]')],
      modularRadioButton: document.getElementById('modular-yes'),
      courseItems: [...document.querySelectorAll('.custom-check')],
      emailInputs: [...document.querySelectorAll('.email')],
      copyButton: document.querySelector('.btn-copy'),
      participantsContainer: document.getElementById('course-participants-container'),
      externalInvoicingInputs: document.querySelectorAll('[data-input-target]'),
    };

    this.props = {
      cloneFields: null,
    };

    this.data = {
      phaseID: null,
      programIds: [],
    };

    this.components = {
      participantsFormValidation: null,
      courseItemsFormValidation: null,
      invoiceFormValidation: null,
      confirmFormValidation: null,
    };

    this.events = {
      vatChangeEvent: this.vatChangeEvent.bind(this),
      updatePriceSelectorEvent: this.updatePriceSelectorEvent.bind(this),
      modularRadioChangeEvent: this.modularRadioChangeEvent.bind(this),
      onCourseItemClickEvent: this.onCourseItemClickEvent.bind(this),
      onFormParticipantsErrorEvent: this.onFormParticipantsErrorEvent.bind(this),
      onFormParticipantsSuccessEvent: this.onFormParticipantsSuccessEvent.bind(this),
      onEmailInputChangeEvent: this.onEmailInputChangeEvent.bind(this),
      onExternalInvoiceInputEvent: this.onExternalInvoiceInputEvent.bind(this),
      onParticipantCountryChangeEvent: this.onParticipantCountryChangeEvent.bind(this),
    };

    this.mount();
  }

  mount() {
    this.initFormFieldsDuplicator();

    this.dom.requestElements
      .map((element) => new ActionComponent({ element, url: element.dataset.requestUrl, action: element.dataset.action }));

    if (this.dom.courseItems) {
      Array.prototype.slice.call(this.dom.courseItems).forEach((courseItem) => {
        courseItem.addEventListener('change', this.events.onCourseItemClickEvent);
      });
    }

    if (this.dom.emailInputs) {
      Array.prototype.slice.call(this.dom.emailInputs).forEach((emailInput) => {
        emailInput.addEventListener('change', this.events.onEmailInputChangeEvent);
      });
    }

    if (this.dom.externalInvoicingInputs) {
      Array.prototype.slice.call(this.dom.externalInvoicingInputs).forEach((input) => {
        input.addEventListener('input', this.events.onExternalInvoiceInputEvent);
      });
    }

    this.dom.datepickers
      .map((element) => new Datepicker({
        element, lang: element.dataset.datepicker, minDate: element.dataset.datepickerMinDate, maxDate: element.dataset.datepickerMaxDate,
      }));

    Inputmask().mask(document.querySelectorAll('[data-inputmask]'));

    if (this.dom.formParticipants) {
      this.components.participantsFormValidation = new Validation(this.dom.formParticipants);
      this.dom.formParticipants.addEventListener('error', this.events.onFormParticipantsErrorEvent);
      this.dom.formParticipants.addEventListener('success', this.events.onFormParticipantsSuccessEvent);
    }

    if (this.dom.formCourseItems) {
      this.components.courseItemsFormValidation = new Validation(this.dom.formCourseItems);
    }

    if (this.dom.formInvoice) {
      this.components.invoiceFormValidation = new Validation(this.dom.formInvoice);
    }

    if (this.dom.formConfirm) {
      this.components.confirmFormValidation = new Validation(this.dom.formConfirm);
    }

    // Toggle the VAT fields
    if (this.dom.selects) {
      Array.prototype.slice.call(this.dom.selects).forEach((select) => {
        select.addEventListener('change', this.events.vatChangeEvent);
      });
    }

    // Action to update the price in the sidebar
    if (this.dom.updatePriceSelectors) {
      Array.prototype.slice.call(this.dom.updatePriceSelectors).forEach((element) => {
        element.addEventListener('change', this.events.updatePriceSelectorEvent);
      });
    }

    // Action to reset the section checkboxes + update price in sidebar
    if (this.dom.modularRadioButton) {
      this.dom.modularRadioButton.addEventListener('change', this.events.modularRadioChangeEvent);
    }

    // Toggle the national registration number field per participant
    if (this.dom.participantsContainer) {
      this.dom.participantsContainer.addEventListener('change', this.events.onParticipantCountryChangeEvent);

      Array.prototype.slice.call(this.dom.participantsContainer.querySelectorAll('.course-participants-child'))
        .forEach((participantPanel) => {
          this.syncNationalNumberField(participantPanel);
        });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  initFormFieldsDuplicator() {
    Array.prototype.slice.call(document.querySelectorAll('[data-copy-element]')).forEach((node) => {
      const duplicator = new FormFieldDuplicator(node, node.dataset.copyCountMax, node.dataset.copyElement, node.dataset.copyContainer);

      duplicator.dom.container.addEventListener(duplicator.customEvents.cloneCreated, (e) => {
        const { clone } = e.detail;
        clone.querySelector('.email').addEventListener('change', this.events.onEmailInputChangeEvent);
        this.syncNationalNumberField(clone);
      });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  vatChangeEvent(e) {
    document.getElementById(e.currentTarget.dataset.bsTarget).classList.toggle('show');
  }

  // eslint-disable-next-line class-methods-use-this
  updatePriceSelectorEvent() {
    const formData = new FormData();
    const url = `${rootWithLanguage}update-price`;
    const selectedCourseSections = [];

    Array.prototype.slice.call(this.dom.updatePriceSelectors).forEach((checkbox) => {
      if (checkbox.checked === true) {
        selectedCourseSections.push(checkbox.value);
      }
    });

    formData.append('PhaseId', document.getElementById('form-participants').dataset.phaseId);
    formData.append('ProgramIds', selectedCourseSections);

    this.send({
      url,
      formData,
    });
  }

  modularRadioChangeEvent() {
    // Uncheck all modular checkboxes
    Array.prototype.slice.call(this.dom.updatePriceSelectors).forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.checked = false;
    });
    this.updatePriceSelectorEvent();
  }

  // eslint-disable-next-line class-methods-use-this
  onCourseItemClickEvent(e) {
    this.data.phaseID = e.currentTarget.dataset.phaseId;

    // Clear the array
    this.data.programIds = [];

    // Loop through all checked checkboxes and add the program id to the array
    document.querySelectorAll('input[type="checkbox"]:checked').forEach((checkbox) => {
      this.data.programIds.push(checkbox.parentElement.dataset.programId);
    });

    const formData = new FormData();
    formData.append('PhaseID', this.data.phaseID);
    formData.append('ProgramIds', this.data.programIds);
    this.send({ url: `${rootWithLanguage}update-programs`, formData });
  }

  /**
   * Sets a global validation when a panel has an error
   */
  // eslint-disable-next-line class-methods-use-this
  onFormParticipantsErrorEvent(e) {
    Array.prototype.slice.call(e.target.querySelectorAll('.course-participants-child')).forEach((courseParticipantsPanel) => {
      const hasError = Array.from(courseParticipantsPanel.querySelectorAll('.validation-feedback')).some((input) => input.classList.contains('is-invalid'));
      if (hasError) {
        courseParticipantsPanel.classList.add('has-validation');
      } else {
        courseParticipantsPanel.classList.remove('has-validation');
      }
    });
  }

  /**
   * Remove the validation class for all panels when they are correct
   * @param e
   */
  // eslint-disable-next-line class-methods-use-this
  onFormParticipantsSuccessEvent(e) {
    Array.prototype.slice.call(e.target.querySelectorAll('.course-participants-child')).forEach((courseParticipantsPanel) => {
      courseParticipantsPanel.classList.remove('has-validation');
    });
  }

  /**
   * The country select of a participant determines whether that participant
   * needs to fill in a national registration number.
   */
  onParticipantCountryChangeEvent(e) {
    if (!e.target.classList.contains('js-participant-country')) return;

    this.syncNationalNumberField(e.target.closest('.course-participants-child'));
  }

  /**
   * Show the national registration number field only when the participant selected the
   * country it applies to. While hidden the input is disabled, so no stale value is posted.
   */
  // eslint-disable-next-line class-methods-use-this
  syncNationalNumberField(participantPanel) {
    if (!participantPanel) return;

    const countrySelect = participantPanel.querySelector('.js-participant-country');
    const nationalNumberField = participantPanel.querySelector('.js-national-number');

    if (!countrySelect || !nationalNumberField) return;

    const nationalNumberInput = nationalNumberField.querySelector('.form-field');
    const selectedCountryCode = countrySelect.selectedOptions[0]?.dataset.countryCode;
    const isRequired = selectedCountryCode === nationalNumberField.dataset.requiredCountryCode;

    nationalNumberField.classList.toggle('d-none', !isRequired);
    nationalNumberInput.disabled = !isRequired;

    if (!isRequired) {
      nationalNumberInput.value = '';
      nationalNumberField.querySelector('.validation-feedback')?.classList.remove('is-invalid');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onEmailInputChangeEvent(e) {
    const email = e.target.value;

    if (email !== '') {
      e.target.closest('.accordion-item').querySelector('.participant-name').textContent = `(${email})`;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onExternalInvoiceInputEvent(e) {
    const targetId = e.target.dataset.inputTarget;
    const targetInput = document.getElementById(targetId);
    const label = targetInput?.nextElementSibling;

    if (e.target.value.length > 0) {
      if (!targetInput || !label) return true;

      // Add existing asterisk (if there is none)
      if (!label.textContent.trim().endsWith('*')) {
        label.textContent = `${label.textContent.trim()} *`;
      }
    } else {
      label.textContent = label.textContent.trim().replace(/\s*\*$/, '');
    }

    return true;
  }
}

if (document.getElementById('page-course-registration')) {
  // eslint-disable-next-line no-new
  new CourseRegistration();
}
